import { FROM_NOTIFICATIONS, NOTIFICATION_ENABLE_URL } from '../constants';
import { updateSessionStorage } from '../utilities';
/**
 * @method RedirectChecker
 * @description checks whether to redirect or not based on tandc
 * @param {redirectUrl} string url to redirect to
 * @param {shouldChecktnc} func checks for tandc
 */
const RedirectChecker = (redirectUrl, shouldChecktnc, enablePreferences = false) => {
  const url = window.location.href;
  if (enablePreferences && url.includes(FROM_NOTIFICATIONS) && !updateSessionStorage.getItem(NOTIFICATION_ENABLE_URL)) {
    updateSessionStorage.setItem(NOTIFICATION_ENABLE_URL, url);
  }
  if (shouldChecktnc && !updateSessionStorage.getItem('tandC')) {
    updateSessionStorage.setItem('redirectlocation', url);
    window.location.pathname = redirectUrl;
  }
  return null;
};

export default RedirectChecker;
